export const isValidOrderCode = (code: string): boolean => {
  // Must be exactly 19 characters
  if (code.length !== 19) {
    return false;
  }

  // Must match format: 8 digits, dash, 6 digits, dash, 3 digits
  if (!/^\d{8}-\d{6}-\d{3}$/.test(code)) {
    return false;
  }

  // Extract components
  const parts = code.split('-');
  if (parts.length !== 3) {
    return false;
  }

  const [datePart, timePart, millisPart] = parts;
  // Validate part lengths
  if (
    datePart.length !== 8 ||
    timePart.length !== 6 ||
    millisPart.length !== 3
  ) {
    return false;
  }

  // Parse components
  const day = parseInt(datePart.substring(0, 2), 10);
  const month = parseInt(datePart.substring(2, 4), 10);
  const year = parseInt(datePart.substring(4, 8), 10);
  const hours = parseInt(timePart.substring(0, 2), 10);
  const minutes = parseInt(timePart.substring(2, 4), 10);
  const seconds = parseInt(timePart.substring(4, 6), 10);
  const millis = parseInt(millisPart, 10);

  // Check for NaN (non-numeric input)
  if ([day, month, year, hours, minutes, seconds, millis].some(isNaN)) {
    return false;
  }

  // Validate time ranges
  if (hours > 23 || minutes > 59 || seconds > 59) {
    return false;
  }

  // Validate milliseconds range
  if (millis < 0 || millis > 999) {
    return false;
  }

  // Validate date using Date object (handles month lengths, leap years, etc.)
  const date = new Date(
    Date.UTC(year, month - 1, day, hours, minutes, seconds)
  );
  if (isNaN(date.getTime())) {
    return false;
  }

  // Verify the date components match (catches invalid dates like Feb 30)
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    return false;
  }

  // Optional: validate year range
  if (year < 1970 || year > 2100) {
    return false;
  }

  return true;
};
